(function () {
    var ROOT_SELECTOR = '[data-bop]';

    function init(root) {
        if (root.dataset.bopReady === 'true') return;

        var track = root.querySelector('[data-bop-track]');
        var dots = root.querySelectorAll('[data-bop-dot]');
        if (!track || dots.length < 2) return;

        var slides = Array.prototype.slice.call(track.children);
        if (slides.length !== dots.length) return;

        root.dataset.bopReady = 'true';

        function activate(index) {
            for (var i = 0; i < dots.length; i++) {
                dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
            }
        }

        function scrollToSlide(index) {
            var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            track.scrollTo({
                left: slides[index].offsetLeft - slides[0].offsetLeft,
                behavior: reduced ? 'auto' : 'smooth'
            });
        }

        function onDotClick(event) {
            scrollToSlide(Array.prototype.indexOf.call(dots, event.currentTarget));
        }

        for (var d = 0; d < dots.length; d++) {
            dots[d].addEventListener('click', onDotClick);
        }

        root.bopScrollTo = scrollToSlide;

        if (!('IntersectionObserver' in window)) return;

        var visible = [];

        var observer = new IntersectionObserver(
            function (entries) {
                for (var i = 0; i < entries.length; i++) {
                    visible[slides.indexOf(entries[i].target)] = entries[i].isIntersecting;
                }

                for (var j = 0; j < visible.length; j++) {
                    if (visible[j]) {
                        activate(j);
                        return;
                    }
                }
            },
            { root: track, threshold: 0.6 }
        );

        for (var s = 0; s < slides.length; s++) {
            observer.observe(slides[s]);
        }
    }

    function initAll(scope) {
        var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
        for (var i = 0; i < roots.length; i++) {
            init(roots[i]);
        }
    }

    initAll();

    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
        var root = event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;
        if (!root || !root.bopScrollTo) return;

        var slide = event.target.closest('.banner-opposition__slide');
        if (!slide) return;

        var slides = slide.parentNode.children;
        for (var i = 0; i < slides.length; i++) {
            if (slides[i] === slide) {
                root.bopScrollTo(i);
                return;
            }
        }
    });
})();
